import { SelectionBoxItem } from '@tryhackme/thm-ui-components';
import { useCallback } from 'react';
import { useUpdateExperienceMutation } from 'src/common/slices/user-experience.slice';
import { experienceLevels } from 'src/features/manage-account/account-details/sections/experience-level/experience-level.constants';
import { StyledContainer, StyledContentContainer, StyledSelectionBox, StyledSubtitle, StyledTitle } from './reprofiling-technical-ability.styles';
interface ReprofilingTechnicalAbilityProps {
  footer: React.ReactNode;
  selectedExperience?: string;
  onSelectedExperienceChange: (experience: string) => void;
  ourSuggestion?: string;
}
export const ReprofilingTechnicalAbility = ({
  footer,
  selectedExperience,
  onSelectedExperienceChange,
  ourSuggestion
}: ReprofilingTechnicalAbilityProps) => {
  const [updateExperienceTrigger] = useUpdateExperienceMutation();
  const onPressExperienceCard = useCallback((experience: string) => {
    void updateExperienceTrigger({
      experience
    }).unwrap();
    onSelectedExperienceChange(experience);
  }, [updateExperienceTrigger, onSelectedExperienceChange]);
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="ReprofilingTechnicalAbility" data-sentry-source-file="reprofiling-technical-ability.tsx">
      <div>
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="reprofiling-technical-ability.tsx">What Fits You Best?</StyledTitle>
        <StyledSubtitle data-sentry-element="StyledSubtitle" data-sentry-source-file="reprofiling-technical-ability.tsx">Pick the stage that matches your experience to enhance recommendations.</StyledSubtitle>
      </div>
      <StyledContentContainer data-sentry-element="StyledContentContainer" data-sentry-source-file="reprofiling-technical-ability.tsx">
        <StyledSelectionBox gap="3.2rem 2.4rem" hasContent data-sentry-element="StyledSelectionBox" data-sentry-source-file="reprofiling-technical-ability.tsx">
          {experienceLevels.map(experienceLevel => {
          const {
            icon,
            option,
            hasContent,
            isDarkVersion
          } = experienceLevel;
          const {
            label,
            value
          } = option;
          return <SelectionBoxItem key={label} option={option} icon={icon} hasContent={hasContent} checked={value === selectedExperience} onChange={() => onPressExperienceCard(value)} isDarkVersion={isDarkVersion} currentSelectionMessage={value === ourSuggestion ? "We think it's you" : undefined} />;
        })}
        </StyledSelectionBox>
      </StyledContentContainer>
      {footer}
    </StyledContainer>;
};